// Since we receive html encoded parameters from the Aareon website
function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, 'text/html')

  if (doc && doc.documentElement) {
    return doc.documentElement.textContent
  } else if (window.ActiveXObject) {
    let xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM')
    xmlDoc.async = false
    return xmlDoc.loadXML(input)
  }
}

/**
 * use this to make a Base64 encoded string URL friendly
 *
 * @param {String} str the string to encode
 * @returns {String} the URL friendly encoded string
 */
export var encode = function Base64EncodeUrl(str) {
  return escape(window.btoa(str))
}

/**
 * Use this to decode a URL friendly Base64 encoded string
 *
 * @param {String} str the encoded string
 * @returns {String} the URL friendly decoded string
 */
export var decode = function Base64DecodeUrl(str) {
  return htmlDecode(window.atob(unescape(str)))
}

// get some examples to test like
// jarms@bots4you.de
// console.log(encode('?firstname=Lennart&lastname=Jarms&company=Bots4You GmbH&email=jarms@bots4you.de&salutation=Herr&customer_id=2003233')) // P2ZpcnN0bmFtZT1MZW5uYXJ0Jmxhc3RuYW1lPUphcm1z
// itgtest1@bots4you.de
// console.log(encode('?firstname=Lennart&lastname=Jarms&company=Bots4You GmbH&email=itgtest1@bots4you.de&salutation=Herr&customer_id=2003233')) // P2ZpcnN0bmFtZT1MZW5uYXJ0Jmxhc3RuYW1lPUphcm1z
// itgtest2@bots4you.de
// console.log(encode('?firstname=Lennart&lastname=Jarms&company=Bots4You GmbH&email=itgtest2@bots4you.de&salutation=Herr&customer_id=2003233')) // P2ZpcnN0bmFtZT1MZW5uYXJ0Jmxhc3RuYW1lPUphcm1z
// long company name with url like http://localhost:8080/abc/def
// console.log(encode('?firstname=Lennart&lastname=Jarms&company=GWG Gesellschaft für Wohn- und Gewerbeimmobilien Halle-Neustadt mbh&email=itgtest2@bots4you.de&salutation=Herr&customer_id=2003233')) // P2ZpcnN0bmFtZT1MZW5uYXJ0Jmxhc3RuYW1lPUphcm1z

// test case with html encoded lastname Mirán (Mir&aacute;n)
//let t = "P2ZpcnN0bmFtZT1NZXJ2YW4mbGFzdG5hbWU9TWlyJmFhY3V0ZTtuJmVtYWlsPW1pcmFuQGJvdHM0eW91LmRlJnNhbHV0YXRpb249SGVyciZjb21wYW55PUB0ZXN0QFJlZ2llYmV0cmllYiZjdXN0b21lcl9pZD0yMDAzMjMz"
// console.log(decode(t))

// console.log(encode('?conversation_id=c67049f0-b1e6-41b5-acba-7cd34c1edefd'))
